<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <md-card class="search-area">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>search</md-icon>
            검색 조건
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th>회비년도</th>
              <td>
                <input type="text" class="w90" maxlength="4" placeholder="YYYY" v-model="query.startFeeYear" v-on:keyup.enter="searchQuery" />
                <span>~</span>
                <input type="text" class="w90" maxlength="4" placeholder="YYYY" v-model="query.endFeeYear" v-on:keyup.enter="searchQuery" />
              </td>
              <th>구분</th>
              <td>
                <label>
                  <input type="radio" value="M" v-model="query.memberType">일반교우
                </label>
                <label>
                  <input type="radio" value="S" v-model="query.memberType">임원진
                </label>
              </td>
              <th>단체구분</th>
              <td>
                <select v-model="query.branchCd" @change="setBranchType(query.branchCd)">
                  <option value="">단체 구분 선택</option>
                  <option v-for="item in branchTypeList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                </select>
              </td>
              <th>단체명</th>
              <td>
                <select v-model="query.branchId">
                  <option value="">단체 선택</option>
                  <option v-for="item in branchList" :key="item.branchId" :value="item.branchId" :label="item.branchNm"></option>
                </select>
              </td>
              <th>학번</th>
              <td>
                <div class="inline-flex">
                  <input type="text" maxlength="2" v-model="query.subHakbun">
                  <span>2자리 숫자만 입력</span>
                </div>
              </td>
            </tr>
            <tr>
              <th>주소변경기간</th>
              <td colspan="9">
                <div class="inline-flex">
                  <input type="text" class="w90" placeholder="YYYY-MM-DD" id="startAddrDate" v-mask="'####-##-##'" v-model="query.startAddrDate" v-on:keyup.enter="searchQuery" />
                  <span>~</span>
                  <input type="text" class="w90" placeholder="YYYY-MM-DD" v-model="query.endAddrDate" v-mask="'####-##-##'" v-on:keyup.enter="searchQuery" />
<!--                  <button>-->
<!--                    <md-icon>date_range</md-icon>-->
<!--                  </button>-->
                  <span>해당 기간 동안, 자택, 직장의 주소가 업데이트 된 것만 조회</span>
                </div>
              </td>
            </tr>
          </table>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="searchQuery">
            <md-icon>check</md-icon>검 색
          </md-button>
          <md-button class="md-default md-sm" @click="clearQuery">
            <md-icon>clear</md-icon>초기화
          </md-button>
          <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel" v-exel-btn="[5,3]">
            <md-icon>get_app</md-icon>Excel 다운로드
          </md-button>
        </md-card-actions>
      </md-card>

      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>assignment</md-icon>검색 결과
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
            <div>
              <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
          <grid ref="executivesGrid"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @response="response"
          ></grid>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import kuaaApi from "@/kuaa/kuaa-api";
import axios from "axios";
import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import moment from "moment";

export default {
  components: {
    grid: Grid
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  created() {
    this.queryBranchTypes();

    moment.locale();

    this.initGrid();
  },

  data() {
    return {
      // 단체구분
      branchTypeList: [],
      // 선택한 단체구분에 해당하는 단체 리스트
      branchList: [],

      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },

      query: {
        startFeeYear: moment().format('YYYY'),
        endFeeYear: moment().format('YYYY'),
        memberType: "M",
        startAddrDate: "",
        endAddrDate: "",
        branchCd: "",
        branchId: "",
        subHakbun: "",
      },
    }
  },

  methods: {
    initQueryDate() {
      let now = moment();
      this.query.endAddrDate = now.format("YYYY-MM-DD");
      this.query.startAddrDate = now.subtract(3, "years").format("YYYY-MM-DD");
    },
    /**
     * branch - 공통코드 조회 세팅
     */
    queryBranchTypes() {
      kuaaFnc.fncBranchTypes(null,res => {
        this.branchTypeList = res.data.data.contents;
      });
    },

    /**
     * 단체 구분 선택했음. 단체 리스트업 해야 함.
     */
    setBranchType(branchGb) {
      // field 명은 branchGb 에 해당하는 것으로 파악
      // 2020.08.25 현재 TB_BRANCH 조회만 되고, 입력/수정이 안되서 테스트 불가능.
      // 테스트할 경우 branchGb 에 부모 공통코드 branchId 를 입력하면 리스트업 될 것임.
      let options = {
        branchGb : branchGb
      }
      kuaaApi.sendServer(
        URL_CONST.GET_BRANCH_LIST,
        options,
        "post",
        response => {
          this.branchList = response.data.data.contents;
        }
      )
    },

    /**
     * 검색 실행
     */
    searchQuery() {
      this.doSearch();
    },

    /**
     * 검색조건 초기화
     */
    clearQuery() {
      this.query = {
        startFeeYear: moment().format('YYYY'),
        endFeeYear: moment().format('YYYY'),
        memberType: "M",
        startAddrDate: "",
        endAddrDate: "",
        branchCd: "",
        branchId: "",
        subHakbun: "",
      };
    },

    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.executivesGrid, event, this.pagination);
    },

    doSearch() {
      console.log('~~~~~~~')
      if(this.query.startFeeYear && this.query.endFeeYear){
        if(this.query.startFeeYear > this.query.endFeeYear) {
          Swal.fire({ html: '회비년도 기간을 정확히 입력해 주세요' });
          return false;
        }
      }

      if(this.query.startFeeYear && (this.query.startFeeYear > moment().format('YYYY'))){
        Swal.fire({html:'회비년도 시작년도는 당해년도 보다 클수 없습니다'});
        return false;
      }

      // if(this.query.endFeeYear && (this.query.endFeeYear > moment().format('YYYY'))){
      //   Swal.fire({html:'회비년도 종료년도는 당해년도 보다 클수 없습니다'});
      //   return false;
      // }

      if(this.query.endAddrDate && !this.query.startAddrDate){
        Swal.fire({html:'시작일[주소변경기간]을 입력해 주세요'});
        return false;
      }

      if(this.query.startAddrDate && this.query.endAddrDate){
        if(this.query.startAddrDate > this.query.endAddrDate) {
          Swal.fire({ html: '주소변경기간을 정확히 입력해 주세요' });
          return false;
        }
      }

      this.$refs.executivesGrid.invoke("readData", 1, this.query);
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_OCR_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.executivesGrid;
      this.gridProps['columns'] = [
          {header: '교우번호', name: 'memberNo',width:70},
          {header: '교우명', name: 'memberHnm', width:70},
          {header: 'OCR번호', name: 'ocrNumber',width:130},
          {header: '회비년도', name: 'feeYear', width:90},
          {header: '납부자번호', name: 'memberNo', width:90},
          {header: '바코드', name: 'barcode', width:130},
          {header: '바코드TEXT', name: 'barcodeText', width:130},
          {header: '학번', name: 'hakbun', width:90},
          {header: '졸업년월', name: 'graduationYm', width:90},
          {header: '대학', name: 'collegeNm', width:100},
          {header: '학과', name: 'classNm', width:100},
          {header: '졸업회수', name: 'graduationNo', width:90},
          {header: '교우직위', name: 'memberorgNm', width:90},
          {header: '금액', name: 'amt', width:90},
          {header: '우편번호', name: 'homeZipcd', width:90},
          {header: '주소 1', name: 'homeAddress1', width:250},
          {header: '주소 2', name: 'homeAddress2', width:250},
          {header: '직장명', name: 'companyNm', width:100},
          {header: '부서', name: 'partNm', width:100},
          {header: '직위', name: 'levelNm', width:100},
        ];
      this.gridProps['columnOptions'].frozenCount = 4;
    },

    response(e) {
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e,"OCR 출력 조회");
      }
    },

    downloadExcel() {
      this.query.page = 1;
      this.query.perPage = this.pagination.total;
      this.query.fileName = 'OCR출력';
      kuaaApi.requestFileDownload(
          URL_CONST.OCR_EXCEL_DOWNLOAD,
          this.query,
          'OCR출력.xlsx',
          response => {
            this.query.page = this.pagination.page;
            this.query.perPage = this.pagination.perPage;
          }
      );
    },
  }
}
</script>

<style scoped>

</style>